import { Component, forwardRef, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { InputBaseComponent } from '../input-base/input-base.component';
import { map, takeUntil } from 'rxjs/operators';
import { merge } from 'rxjs';
import { InputAutocomplete } from '../enums';
import { LocaleSettings } from 'primeng/datepicker';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'input-datepicker',
  templateUrl: './input-datepicker.component.html',
  styleUrls: ['./input-datepicker.component.scss'],
  providers: [{ provide: InputBaseComponent, useExisting: forwardRef(() => InputDatepickerComponent) }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputDatepickerComponent extends InputBaseComponent implements OnInit {

  public de?: LocaleSettings;

  @Input() public appendTo?: unknown = 'body';
  @Input() public dateFormat: string = 'dd.mm.yy';
  @Input() public placeholder?: string;
  @Input() public autocomplete: InputAutocomplete = InputAutocomplete.Off;
  @Input() public disabledDays: number[] = [];
  @Input() public readonlyInput: boolean = true;     // prevent typing - only selecting allowed
  @Input() public view: 'date' | 'month' | 'year' = 'date';
  @Input() public showTime: boolean = false;
  @Input() public minDate?: Date;
  @Input() public maxDate?: Date;

  public value?: Date; // used in template instead of this.control - the control contains a date-string

  public override ngOnInit(): void {
    super.ngOnInit();
    if (['number', 'string'].includes(typeof this.control.value)) {
      this.value = new Date(this.control.value);
    }

    // TODO - deprecated
    this.de = {
      firstDayOfWeek: 1,
      dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
      dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      today: 'Heute',
      clear: 'leeren',
      dateFormat: 'dd.mm.yy',
      weekHeader: 'KW'
    };

    merge(this.control.valueChanges, this.controlReplaced.pipe(map(() => this.control.value)))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((v) => {
        // TODO check why we need this this.control.markAsTouched();
        if (!v) {
          this.value = undefined;
        }
      });
  }

  public setValue(): void {
    setTimeout(() => {
      this.control.setValue(typeof this.value?.getMonth === 'function' ? new Date(this.value).toISOString() : undefined);
    }, 100);
  }
}
